import React, { useState } from "react"
import Modal from "react-modal"
import Select from "react-select"

import closeIcon from "../../assets/img/cross-icon.svg"
import { docModalStylesAdminDinamo } from "../utils/styles"
import { customStyles, SingleOption } from "../utils/utils"
import { displayLoader, hideLoader } from "../utils/windows"

const RegularizacionEspecialModal = ({
  displayModal,
  closeModal,
  data,
  selectedEds,
  selectedPagador,
  callServiceHandler,
  onSuccess,
}) => {
  const [tipoVenta, setTipoVenta] = useState()
  const [material, setMaterial] = useState()
  const [envioCopec, setEnvioCopec] = useState()
  const [tanque, setTanque] = useState()
  const [monto, setMonto] = useState()
  const [litros, setLitros] = useState()
  const [precio, setPrecio] = useState()
  const [observacion, setObservacion] = useState()

  const tipoVentaOptions = [
    { label: "Combustible", value: "combustible" },
    { label: "Productos", value: "productos" },
  ]

  const materialOptions = [
    { label: "DIESEL", value: "DIESEL" },
    { label: "GAS 93", value: "GAS 93" },
    { label: "GAS 95", value: "GAS 95" },
    { label: "GAS 97", value: "GAS 97" },
    { label: "KEROSENE", value: "KEROSENE" },
  ]

  const envioCopecOptions = [
    { label: "SI", value: "SI" },
    { label: "NO", value: "NO" },
  ]

  async function guardarRegularizacionEspecial() {
    displayLoader()

    const url =
      process.env.REACT_APP_FLUCTUACIONES_API +
      "/fluctuaciones/leer-datos-cierre-dinamo"

    const baseItem = data && data.length > 0 ? data[0] : {}

    const body = {
      ACCION: "INGRESAR_REG_ESPECIAL",
      datos: {
        tanque: tanque,
        monto: monto,
        eds: selectedEds?.value || baseItem.eds,
        material: material?.value,
        fecha_regularizacion: baseItem.fecha_regularizacion,
        litros: litros,
        observacion: observacion,
        pagador: selectedPagador?.value || baseItem.pagador,
        envio_copec: envioCopec?.value,
        precio: precio,
        tipo_venta: tipoVenta?.value,
      },
    }

    const result = await callServiceHandler(
      url,
      "POST",
      JSON.stringify(body)
    )

    hideLoader()

    if (result !== "error" && result?.code === 200)
      onSuccess(result.data.mensaje)

  }

  return (
    <Modal
      isOpen={displayModal}
      onRequestClose={closeModal}
      style={docModalStylesAdminDinamo()}
    >
      <button className="modal__close-btn" onClick={closeModal}>
        <img src={closeIcon} alt="close modal" />
      </button>

      <div className="documento-info-modal admin-dinamo-modal">
        <div className="title">Regularización especial</div>

        <div className="content">
          <table className="admin-dinamo-modal-table">
            <thead>
              <tr>
                <th>
                  ID REG<br />
                  ID SAP
                </th>
                <th>
                  Fecha Creacion<br />
                  Fecha Ingreso<br />
                  Fecha REG
                </th>
                <th>
                  Material<br />
                  Tipo<br />
                  Tanque
                </th>
                <th>
                  Precio<br />
                  Monto
                </th>
                <th>
                  Litros
                </th>
                <th>
                  Tipo VTA<br />
                  Estado<br />
                  Envío SAP
                </th>
                <th>
                  OBS
                </th>
              </tr>
              <tr className="table-separator-row-border-top">
                <td colSpan="100%" />
              </tr>
            </thead>
            <tbody>
              {data?.map((item) => (
                <tr className="data" key={item.id_regularizacion}>
                  <td className="align-left">
                    {item.id_regularizacion || "-"}<br />
                    {item.id_sap || "-"}
                  </td>
                  <td className="align-left">
                    {item.fecha_creacion || "-"}<br />
                    {item.fecha_regularizacion || "-"}<br />
                    {item.fecha_ingreso || "-"}
                  </td>
                  <td className="align-left">
                    {item.material}<br />
                    {item.tipo_material || "-"}<br />
                    {item.tanque || "-"}
                  </td>
                  <td className="align-right">
                    {item.precio || "-"}<br />
                    {item.monto || "-"}
                  </td>
                  <td className="align-right">{item.litros}</td>
                  <td className="align-left">
                    {item.tipo_venta || "-"}<br />  
                    {item.estado || "-"}<br />
                    {item.envio_copec || "-"}
                  </td>
                  <td><div className="obs-col">{item.observacion || "-"}</div></td>
                </tr>
              ))}
            </tbody>
          </table>

          <hr />

          <div className="admin-dinamo-modal-form">
            <div className="admin-dinamo-modal-form--title">
              Ingresar Regularización Especial
            </div>
            <div className="admin-dinamo-modal-form-row">
              <div className="admin-dinamo-modal-field">
                <div className="admin-dinamo-modal-label">Tipo venta</div>
                <Select
                  className="eds-select"
                  value={tipoVenta}
                  onChange={(e) => setTipoVenta(e)}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  options={tipoVentaOptions}
                  components={{ SingleOption, IndicatorSeparator: () => null }}
                  isClearable={false}
                  autosize={false}
                  placeholder="Seleccionar"
                  styles={customStyles}
                />
              </div>

              <div className="admin-dinamo-modal-field">
                <div className="admin-dinamo-modal-label">Material</div>
                <Select
                  className="eds-select"
                  value={material}
                  onChange={(e) => setMaterial(e)}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  options={materialOptions}
                  components={{ SingleOption, IndicatorSeparator: () => null }}
                  isClearable={false}
                  autosize={false}
                  placeholder="Seleccionar"
                  styles={customStyles}
                />
              </div>

              <div className="admin-dinamo-modal-field">
                <div className="admin-dinamo-modal-label">Envío SAP</div>
                <Select
                  className="eds-select"
                  value={envioCopec}
                  onChange={(e) => setEnvioCopec(e)}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  options={envioCopecOptions}
                  components={{ SingleOption, IndicatorSeparator: () => null }}
                  isClearable={false}
                  autosize={false}
                  placeholder="Seleccionar"
                  styles={customStyles}
                />
              </div>
            </div>

            <div className="admin-dinamo-modal-form-row">
              <div className="admin-dinamo-modal-field">
                <div className="admin-dinamo-modal-label">Tanque</div>
                <input type="text" value={tanque} onChange={(e) => setTanque(e.target.value)}></input>
              </div>

              <div className="admin-dinamo-modal-field">
                <div className="admin-dinamo-modal-label">Monto</div>
                <input type="text" value={monto} onChange={(e) => setMonto(e.target.value)}></input>
              </div>

              <div className="admin-dinamo-modal-field">
                <div className="admin-dinamo-modal-label">Litros</div>
                <input type="text" value={litros} onChange={(e) => setLitros(e.target.value)}></input>
              </div>
            </div>

            <div className="admin-dinamo-modal-form-row">
              <div className="admin-dinamo-modal-field">
                <div className="admin-dinamo-modal-label">Precio</div>
                <input type="text" value={precio} onChange={(e) => setPrecio(e.target.value)}></input>
              </div>

              <div className="admin-dinamo-modal-field">
                <div className="admin-dinamo-modal-label">Observaciones</div>
                <input type="text" value={observacion} onChange={(e) => setObservacion(e.target.value)}></input>
              </div>
            </div>

             <button className="main-button" onClick={guardarRegularizacionEspecial}>Guardar</button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default RegularizacionEspecialModal


